"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _TagsGroup = _interopRequireDefault(require("../TagsGroup/TagsGroup"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const getFormattedDate = date => {
  const format = date?.split('-');
  if (format.length !== 3) return '';
  const day = format[2];
  const month = format[1];
  const year = format[0];
  return `${day}.${month}.${year}`;
};
const getFormattedDates = date_times => {
  if (!(date_times?.length > 0)) return '';
  if (date_times?.length === 1) return getFormattedDate(date_times[0].date[0]);
  const first_date = getFormattedDate(date_times[0].date[0]);
  const last_date = getFormattedDate(date_times[date_times.length - 1].date[0]);
  if (first_date === last_date) return first_date;
  return `${first_date.slice(0, 6)} - ${last_date}`;
};
const Wrapper = _ref => {
  let {
    content_type,
    onClick,
    lang,
    event_occurrence_code,
    evenito_link,
    children
  } = _ref;
  return content_type == 'event_occurrence' || content_type == 'organisation_event' ? evenito_link?.url ? /*#__PURE__*/_react.default.createElement("a", {
    target: "_blank",
    href: evenito_link?.url
  }, children) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: `/${lang}/agenda/${event_occurrence_code}`,
    onClick: onClick,
    style: {
      maxWidth: '100%'
    }
  }, children) : /*#__PURE__*/_react.default.createElement("div", null, children);
};
const EventoccurrenceItem = _ref2 => {
  let {
    title,
    status,
    status_label,
    date_times,
    format,
    organisator,
    languages,
    lang,
    code,
    locations,
    times,
    content_type,
    evenito_link,
    onClick
  } = _ref2;
  const date = getFormattedDates(date_times || times);
  const locationsTags = locations ? locations.map(el => ({
    label: el.label,
    type: 'primary'
  })) : [];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "event-occurrence-item sia-border-01-bottom"
  }, /*#__PURE__*/_react.default.createElement(Wrapper, {
    content_type: content_type,
    evenito_link: evenito_link,
    onClick: onClick,
    lang: lang,
    event_occurrence_code: code
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-padding-03-top sia-padding-03-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "top sia-margin-01-bottom"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-06",
    dangerouslySetInnerHTML: {
      __html: date
    }
  }), code && /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-07",
    dangerouslySetInnerHTML: {
      __html: code
    }
  }), status && status === 'event_occurrence_status_fully_booked' && /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-02 ",
    dangerouslySetInnerHTML: {
      __html: status_label
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "bottom"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "name sia-text-04",
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "tags"
  }, /*#__PURE__*/_react.default.createElement(_TagsGroup.default, {
    items: [...locationsTags, ...(organisator ? [{
      label: organisator.label,
      type: 'secondary'
    }] : []), ...(format && format?.length ? [{
      label: format[0].name,
      type: 'tertiary'
    }] : []), ...(languages?.length > 0 ? languages.map(language => {
      return {
        label: language.id?.slice(0, 2)?.toUpperCase(),
        type: 'tertiary'
      };
    }) : [])]
  }))))));
};
var _default = exports.default = EventoccurrenceItem;